"use client";

import React from "react";
import { FaCheckCircle, FaFileContract } from "react-icons/fa";
import Jazzicon, { jsNumberForAddress } from "react-jazzicon";
import styles from "./AccountsPage.module.css";
import { AccountItem } from "./types";
import { formatBalance } from "./utils";

interface AccountRowProps {
  item: AccountItem;
  rank: number;
}

const AccountRow: React.FC<AccountRowProps> = ({ item, rank }) => {
  return (
    <tr>
      <td data-label="Rank">
        <span className={styles.rank}>{rank}</span>
      </td>
      <td data-label="Address">
        <div className={styles.addressCell}>
          {item.is_contract ? (
            <FaFileContract
              size={18}
              className={styles.addressIcon}
              color="#3b82f6"
            />
          ) : (
            <span className={styles.addressIcon} style={{ display: "inline-flex" }}>
              <Jazzicon diameter={18} seed={jsNumberForAddress(item.hash)} />
            </span>
          )}
          <a href={`/address/${item.hash}`} className={styles.link}>
            {item.name || item.hash}
          </a>
          {item.is_contract && (
            <span className={styles.contractBadge}>Contract</span>
          )}
        </div>
      </td>
      <td data-label="Balance">
        <span className={styles.balance}>
          {formatBalance(item.coin_balance)} OGPU
        </span>
      </td>
      <td data-label="Verified">
        {item.is_verified ? (
          <FaCheckCircle size={16} color="#22c55e" />
        ) : (
          <span className={styles.notVerified}>—</span>
        )}
      </td>
      <td data-label="Txn count">
        <span className={styles.txCount}>
          {item.transaction_count?.toLocaleString() || "0"}
        </span>
      </td>
    </tr>
  );
};

export default AccountRow;
